export default {
  // 搜索区
  batchSn: '码批次',
  batchSnPlaceholder: '请输入码批次',
  qrcode: '二维码',
  qrcodePlaceholder: '请输入二维码',
  // 表格列
  colBatchSn: '码批次',
  colName: '码批次名称',
  colCodeRange: '二维码区间',
  colCodeCount: '二维码数量',
  colCodeRemark: '码批次说明',
  colStatus: '状态',
  colCreatedAt: '添加时间',
  colUpdatedAt: '更新时间',
  colRemark: '备注',
  colAction: '操作',
  // 操作
  editRemark: '编辑备注',
  // 编辑备注弹窗
  editRemarkTitle: '编辑备注',
  remark: '备注',
  remarkPlaceholder: '请输入备注内容',
  // 空状态
  emptyText: '暂无码批次数据',
};
